import axios from 'axios';

export type NewsletterAudience = 'purchasing' | 'sales';

export type Newsletter = {
  id: string,
  title: string,
  /** The campaign's preview text, or null when it only repeated the subject. */
  summary: string | null,
  sentAt: string,
  archiveUrl: string | null,
}

export const getNewsletters = async (audience: NewsletterAudience): Promise<Newsletter[]> => {
  const response = await axios.get('/api/updates/newsletters', { params: { audience } });
  return response.data;
}

export const getNewsletterContent = async (campaignId: string): Promise<string> => {
  const response = await axios.get(`/api/updates/newsletters/${campaignId}/content`);
  return response.data.html;
}
